module.exports = __webpack_public_path__ + "img/profile-user.dfc90771.svg";